import { AuthGardService } from './shared/provider-service/auth-gard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: "",
    loadChildren: () => import('app/core/home/home.module').then(m => m.HomeModule),
  }, {
    path: "login",
    loadChildren: () => import('app/core/login/login.module').then(m => m.LoginModule),
  }, {
    path: "landing",
    loadChildren: () => import('app/core/landing/landing.module').then(m => m.LandingModule),
  }, {
    path: "merchant/home",
    canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/merchant-home/merchant-home.module').then(m => m.MerchantHomeModule),
  }, {
    path: "merchant/claims",
    canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/claims/claims.module').then(m => m.ClaimsModule),
  }, {
    path: "merchant/offers",
    canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/offers-details/offers-details.module').then(m => m.OffersDetailsModule),
  }, {
    path: "merchant/search/:keyword",
    canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/offers-details/offers-details.module').then(m => m.OffersDetailsModule),
  },
  {
    path: "addons/:userPackage",
    // canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/addons/addons.module').then(m => m.AddonsModule),
  }, {
    path: "addons/:userPackage/:addonPackage",
    // canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/addons-details/addons-details.module').then(m => m.AddonsDetailsModule),
  }, {
    path: "profile",
    canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/profile/profile.module').then(m => m.ProfileModule),
  }, {
    path: "register",
    loadChildren: () => import('app/core/register/register.module').then(m => m.RegisterModule),
  }, {
    path: "forgot-password",
    loadChildren: () => import('app/core/forgotPass/forgot-pass.module').then(m => m.ForgotPassModule),
  }, {
    path: "reset-password",
    loadChildren: () => import('app/core/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
  }, {
    path: "verify-code",
    loadChildren: () => import('app/core/verify-code/verify-code.module').then(m => m.VerifyCodeModule),
  }, {
    path: "user/wishlist",
    canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/wishlist/wishlist.module').then(m => m.WishlistModule),
  }, {
    path: "plus",
    // canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/plus-deals/plus-deals.module').then(m => m.PlusDealsModule),
  }, {
    path: "terms",
    // canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/terms/terms.module').then(m => m.TermsModule),
  }, {
    path: "about",
    loadChildren: () => import('app/core/about/about.module').then(m => m.AboutModule),
  }, {
    path: "contact-us",
    loadChildren: () => import('app/core/contact-us/contact-us.module').then(m => m.ContactUsModule),
  }, {
    path: "faqs",
    loadChildren: () => import('app/core/faqs/faqs.module').then(m => m.FaqsModule),
  }
  // user
  , {
    path: "user/categories",
    // canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/categories/categories.module').then(m => m.CategoriesModule),
  }, {
    path: "user/home",
    // canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/home/home.module').then(m => m.HomeModule),
  }, {
    path: "user/packages",
    // canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/packages/packages.module').then(m => m.PackagesModule),
  }, {
    path: "user/payment/:root_package",
    canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/payment/payment.module').then(m => m.PaymentModule),
  }, {
    path: "user/payment-state",
    canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/payment-state/payment-state.module').then(m => m.PaymentStateModule),
  }, {
    path: "user/editInfo",
    canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/edit-account/edit-account.module').then(m => m.EditAccountModule),
  }, {
    path: "user/notifications",
    canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/notifications/notifications.module').then(m => m.NotificationsModule),
  }, {
    path: "brand/:id",
    // canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/brandOffers/brand-offers.module').then(m => m.BrandOffersModule),
  }, {
    path: "brand-offer/:offer",
    // canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/offer/offer.module').then(m => m.OfferModule),
  }, {
    path: "coupon-brand",
    // canActivate: [AuthGardService], runGuardsAndResolvers: 'always',
    loadChildren: () => import('app/core/coupon_promotion/coupon-promotion.module').then(m => m.CouponPromotionModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
